module.exports = __webpack_public_path__ + "static/media/cardtouch.14419fe2.png";